export const calcYear = (date: Date, year: number) => {
  const newDate = new Date(date.getTime())
  newDate.setFullYear(date.getFullYear() + year)
  return newDate
}
export const calcMonth = (date: Date, month: number) => {
  const newDate = new Date(date.getTime())
  newDate.setMonth(date.getMonth() + month)
  return newDate
}

export const calcDay = (date: Date, day: number) => {
  const newDate = new Date(date.getTime())
  newDate.setDate(date.getDate() + day)
  return newDate
}

export const calcTime = (date: Date, time: number) => {
  const newDate = new Date(date.getTime())
  newDate.setTime(date.getTime() + time)
  return newDate
}
